import clsx from "clsx";
import React, { forwardRef, PropsWithChildren, useCallback } from "react";

import { CommonColors } from "../../../../types/colors";
import { colorScheme } from "./styles";

export interface SquaredTabsHeaderProps {
  className?: string;
  color: CommonColors;
  tabIndicatorWidth: number;
  tabIndicatorLeft: number;
}

export const SquaredTabsHeader = forwardRef<
  HTMLDivElement,
  PropsWithChildren<SquaredTabsHeaderProps>
>(({ className, children, color, tabIndicatorWidth, tabIndicatorLeft }, ref) => {
  const { inactiveColor, activeColor } = colorScheme[color];

  const renderBorderDecorations = useCallback(
    (side: "left" | "right") => {
      return (
        <div
          className={clsx(
            "absolute bottom-0 w-6 h-6 transition-all duration-300 ease-in",
            inactiveColor,
            side === "left" ? "-left-2 rounded-br-2xl" : "right-0 rounded-bl-2xl"
          )}
        />
      );
    },
    [inactiveColor]
  );

  return (
    <div
      ref={ref}
      className={clsx(
        "transition-all duration-300 ease-in relative",
        "flex px-2 overflow-x-auto no-scrollbar 2xl:justify-center",
        inactiveColor,
        className
      )}
    >
      <div
        className={clsx(
          "w-full absolute bottom-[-1px] h-full overflow-hidden",
          "transition-all duration-300"
        )}
        style={{ left: tabIndicatorLeft, width: tabIndicatorWidth }}
      >
        <div className="w-full h-full relative">
          {/* rounded borders */}
          <div
            className={clsx("absolute bottom-0 left-[1px] h-4", activeColor)}
            style={{
              width: "calc(100% - 2px)",
            }}
          />
          {/* active color area */}
          <div
            className={clsx("absolute bottom-0 left-4 rounded-t-2xl", activeColor)}
            style={{
              width: "calc(100% - 40px)",
              height: "calc(100% - 8px)",
            }}
          />
        </div>
        {renderBorderDecorations("left")}
        {renderBorderDecorations("right")}
      </div>
      {children}
    </div>
  );
});
